import React, { useState, useEffect } from 'react';
import '../styles/cookie.css' 

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // 1. Daha önce kabul edilmiş mi kontrol et
    const cookieConsent = localStorage.getItem('cookie_consent_status');
    if (!cookieConsent) {
      // Eğer kayıt yoksa 1 saniye sonra banner'ı göster
      const timer = setTimeout(() => setIsVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    const consentData = {
      accepted: true,
      date: new Date().toISOString(),
      version: "1.0"
    };
    // 2. LocalStorage'a kaydet
    localStorage.setItem('cookie_consent_status', JSON.stringify(consentData));
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="cookie-banner-overlay">
      <div className="cookie-container">
        <p>
          Size daha iyi bir deneyim sunabilmek için çerezleri kullanıyoruz. 
          Sitemizi kullanarak çerez politikamızı kabul etmiş sayılırsınız.
        </p>
        <div className="cookie-buttons">
          <button className="cookie-btn-outline" onClick={() => setIsVisible(false)}>Reddet</button>
          <button className="cookie-btn-fill" onClick={handleAccept}>Anladım, Kabul Et</button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;